/** API route map: URLS.Controller.Document */
export const Document = {
      Name: 'Document/',
      GetAllDocument: 'employee-attachments',
};
